import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: string;
  type: 'signal' | 'entity' | 'reminder';
}

const signalColors: Record<string, string> = {
  new: 'bg-blue-100 text-blue-700',
  awaiting_review: 'bg-yellow-100 text-yellow-700',
  confirmed: 'bg-green-100 text-green-700',
  reminder_created: 'bg-purple-100 text-purple-700',
  in_progress: 'bg-indigo-100 text-indigo-700',
  resolved: 'bg-gray-100 text-gray-600',
  dismissed: 'bg-gray-100 text-gray-500',
  merged: 'bg-teal-100 text-teal-700',
};

const entityColors: Record<string, string> = {
  detected: 'bg-blue-100 text-blue-700',
  confirmed: 'bg-green-100 text-green-700',
  scheduled: 'bg-indigo-100 text-indigo-700',
  in_production: 'bg-purple-100 text-purple-700',
  ready: 'bg-emerald-100 text-emerald-700',
  delivered: 'bg-teal-100 text-teal-700',
  completed: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-red-100 text-red-700',
};

const reminderColors: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-700',
  snoozed: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  dismissed: 'bg-gray-100 text-gray-500',
  overdue: 'bg-red-100 text-red-700',
};

const colorMaps: Record<string, Record<string, string>> = {
  signal: signalColors,
  entity: entityColors,
  reminder: reminderColors,
};

function getTranslationKey(status: string, type: string): string {
  if (type === 'entity') return `entities.lifecycle.${status}`;
  return `status.${status}`;
}

export default function StatusBadge({ status, type }: StatusBadgeProps) {
  const { t } = useTranslation();
  const colors = colorMaps[type]?.[status] ?? 'bg-gray-100 text-gray-600';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${colors}`}
    >
      {t(getTranslationKey(status, type))}
    </span>
  );
}
